module.exports = __webpack_public_path__ + "static/media/covi_wel_enh_cle.77d56861.png";